'use client';
import React, { useState, useEffect } from 'react';
import Homep from '@/app/componenets/Homep';
import { notFound } from 'next/navigation';
import Section from '@/app/states/[statesPage]/section1';
import Cta from '@/app/states/[statesPage]/ctabanner';
import Section1 from '@/app/states/[statesPage]/section2';
import Cities from '@/app/states/[statesPage]/cities';
import MainData from '@/app/data/MainState';
import TawkTo from '../../componenets/Tawko';
import Navbar from '@/app/componenets/Navbar';
import Footer from '@/app/componenets/Footer';
function page({ params }) {
  // console.log(MainData, params, "hellllllll");
  const [image, setImage] = useState('');
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const mapping = MainData?.find((p) => p?.link === params.statesPage);
  // console.log(mapping, "mapping");

  if (!mapping) {
    notFound(); // Ye Next.js ko 404 page dikhaane ke liye bolta hai
  }
  useEffect(() => {
    if (mapping) {
      const data = mapping?.data[0];
      setImage(data.hero_image);
      setTitle(data.title);
      setSubtitle(data.subtitle);
    }
  }, [mapping]);

  // console.log(image, "iiiii");

  return (
    <div>
      <title>
        {mapping?.data?.length > 0
          ? mapping.data[5].metaTitle
          : 'Prestige Ride | First-Class Black Car & Chauffeur Services'}
      </title>

      <meta
        name="description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[5].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />

      {/* <!-- Facebook Meta Tags --> */}
      <meta
        property="og:url"
        content={mapping?.data?.length > 0 ? mapping.data[5].Link : ''}
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[5].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        property="og:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[5].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg" // Dynamically update this if needed
      />

      {/* <!-- Twitter Meta Tags --> */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta
        property="twitter:url"
        content={mapping?.data?.length > 0 ? mapping.data[5].Link : ''}
      />
      <meta
        name="twitter:title"
        content={
          mapping?.data?.length > 0
            ? mapping.data[5].metaTitle
            : 'Prestige Ride | First-Class Black Car & Chauffeur Services'
        }
      />
      <meta
        name="twitter:description"
        content={
          mapping?.data?.length > 0
            ? mapping.data[5].metaDescription
            : 'Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable.'
        }
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg" // Dynamically update this if needed
      />

      <meta name="robots" content="index, follow" />
      <meta
        name="keywords"
        content={mapping?.data?.length > 0 ? mapping.data[5].metaKeywords : ''}
      />
      <link
        rel="canonical"
        href={mapping?.data?.length > 0 ? mapping.data[5].Link : ''}
      />
      <TawkTo />
      <Navbar />
      <Homep image={image} title={title} subtitle={subtitle} />
      <Section Mydata={mapping?.data} />
      <Cta Mydata={mapping?.data} />
      <Section1 Mydata={mapping?.data} />
      <Cities Mydata={mapping?.data} />
      <Footer />
    </div>
  );
}

export default page;
